export default (el, { expression }, { evaluateLater, effect }) => {
  let evaluate = evaluateLater(expression)

  const minLetters = 3
  const minLines = 1

  function ksort(w) {
    var sArr = []
    var tArr = []
    var n = 0
    for (i in w) {
      tArr[n++] = i
    }
    //tri du plus petit au plus grand
    tArr = tArr.sort()
    n = tArr.length
    for (var i = 0; i < n; i++) {
      sArr[tArr[i]] = w[tArr[i]]
    }
    return sArr
  }

  effect(() => {
    evaluate((value) => {
      const words = value.split(' ')
      const lines_quantity = words.length > 3 ? 4 : 2

      let groups = {}
      for (var i = words.length - 1; i >= 0; i--) {
        let key = parseInt((i * lines_quantity) / words.length)
        let word = words[i]

        if (word.length <= minLetters) {
          while (key < lines_quantity && !groups.hasOwnProperty(key)) {
            key += 1
          }
        }

        let prevKey = Object.keys(groups).pop()
        if (prevKey && prevKey != key && groups[prevKey].length == 1 && groups[prevKey][0].length < minLetters) {
          key = prevKey
        }

        if (!groups.hasOwnProperty(key)) {
          groups[key] = []
        }
        groups[key].unshift(word)
      }

      ksort(
        Object.keys(groups)
          .filter((k) => groups[k].length)
          .reduce((a, k) => ({ ...a, [k]: groups[k] }), {})
      )

      if (groups.length < minLines) {
        for (i = 0; i < minLines - groups.length; i++) {
          groups.unshift([])
        }
      }

      const lastKey = Object.keys(groups).pop()
      el.innerHTML = `<span>
        ${Object.keys(groups)
          .map((key) => {
            return `<span class="block hyphens-auto"><span class="inline-block">${groups[key].join(' ')}</span>${key == lastKey ? el.innerHTML : ''}</span>`
          })
          .join('')}
        </span>`
    })
  })
}
